import React, { Suspense } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import api from '../../api';
import { Button, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { RoleItem } from '../../types';
import Wrapper from '~/App/components/Wrapper';
import Header from '~/App/components/Header';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import Loading from '~/App/components/Loading';

const ListRoleTable = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchAllRole'],
    queryFn: () => {
      return api.getManyRole();
    },
  });
  const navigate = useNavigate();

  const columns: ColumnsType<RoleItem> = [
    {
      dataIndex: 'roleName',
      title: 'Role',
    },
    {
      title: 'Action',
      render: (_, item) => {
        return (
          <Button
            type="primary"
            onClick={() => navigate(`edit/${item.restaurantRoleId}`)}
          >
            Edit
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={data} columns={columns} />;
};

const ListRole = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <div className="flex justify-between">
        <Header title="Role List" />
        <Button type="primary" onClick={() => navigate('create')}>
          + Create
        </Button>
      </div>
      <ErrorBoundary>
        <Suspense fallback={<Loading className="h-[400px]" />}>
          <ListRoleTable />
        </Suspense>
      </ErrorBoundary>
    </Wrapper>
  );
};

export default ListRole;
